module.exports = __webpack_public_path__ + "12a7d61c4b71879ee4d7e3da94792948.png";